import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { DataConvenioEntity } from '../../../../data/repositories/configuration/entities/convenio.entity';
import { ConvenioModel } from '../../../models/configuration/convenio.model';


export class DeleteConvenioUseCase implements UseCase<DataConvenioEntity, ConvenioModel> {
	constructor(private configRepository: ConfigurationRepository) { }
	execute(
		params: DataConvenioEntity,
	): Observable<ConvenioModel> {
		return this.configRepository.deleteConvenio(params);
	}
}
